module.exports = __webpack_public_path__ + "static/media/22ESCWA14.7bf34a2f.jpg";